/*
 * Copyright (c) 2023-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {MomentumProgram} from './momentumProgram.model';
import {SearchUser} from '../shared/model/user';
import {MomentumProgramAccess} from './momentumProgramAccess';
import {ValidationModel} from './validation.model';

export class RestrictedMomentumProgram extends ValidationModel {
  constructor(momentumProgram) {
    super();
    this.momentumProgram = momentumProgram;
  }
  readonly momentumProgram: MomentumProgram;
  users: SearchUser[];

  setProgramAccess(programAccessList: MomentumProgramAccess[]) {
    this.users = new Array<SearchUser>();
    programAccessList.forEach(o => {
      const user = new SearchUser();
      user.gmin = o.gmin;
      user.fullName = o.fullName;
      this.users.push(user);
    })
  }
}
